import { Import as IFCImport, Export as IFCExport } from "./index";

export const Import = IFCImport; 
export const Export = IFCExport; 
